import React from 'react';
import { Tabs } from 'src/shared/design-system/Tabs';
import { useTwoColumn } from './hooks';
import {
  Container,
  TabContainer,
  TabContentContainer,
  TabContentsWrapper,
  TabContentWrapper,
  TabContentWrapperLarge,
} from './styles';
import { Column, TwoColumnProps } from './types';

export const TwoColumnComponent: React.FC<TwoColumnProps> = (props) => {
  const {
    children,
    dockTabsAtTop,
    emphasizeColumns,
    isLeftColumnActive,
    largeLeftColumn,
    leftColumnContent,
    rightColumnContent,
    showLeftColumn,
    showRightColumn,
    showTabsOnMobile,
    showTabsOnTablet,
    tabProps,
    topContent,
  } = useTwoColumn(props);

  const LeftColumnWrapper = largeLeftColumn ? TabContentWrapperLarge : TabContentWrapper;

  return (
    <Container>
      <TabContainer
        showTabsOnMobile={showTabsOnMobile}
        showTabsOnTablet={showTabsOnTablet}
        dockTabsAtTop={dockTabsAtTop}>
        <Tabs {...tabProps} />
      </TabContainer>
      {topContent && <div>{topContent}</div>}
      <TabContentContainer>
        <TabContentsWrapper
          isLeftColumnActive={isLeftColumnActive}
          showTabsOnMobile={showTabsOnMobile}
          showTabsOnTablet={showTabsOnTablet}
          emphasizeColumns={emphasizeColumns}>
          {showLeftColumn && <LeftColumnWrapper data-role='left-column'>{leftColumnContent}</LeftColumnWrapper>}
          {showRightColumn && <TabContentWrapper data-role='right-column'>{rightColumnContent}</TabContentWrapper>}
        </TabContentsWrapper>
      </TabContentContainer>
      {children}
    </Container>
  );
};

// eslint-disable-next-line functional/immutable-data -- Assign Two Column Component
export const TwoColumn = Object.assign(TwoColumnComponent, { Column });
